import { useMemo } from "react";
import { Navigate, generatePath } from "react-router";

import { formatDate } from "@/lib/dayjs/format-date";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import { PATHS } from "@/routes/paths";

import { CreateOptionPmsPresenter } from "./presenter";
import * as Repository from "../../_repository";

export type Props = {
	hotelID: string;
	searchDate: string;
	onCloseCallback: () => void;
};

export const CreateOptionPmsContainer = ({ hotelID, searchDate, onCloseCallback }: Props) => {
	/**
	 * 検索日の初期値
	 */
	const initSearchDate = useMemo(() => {
		const date = searchDate ?? getTodaysDate();
		return formatDate(date, "YYYY-MM-DD");
	}, [searchDate]);
	/**
	 * オプション一覧の取得
	 */
	const { optionPmsGetAvailableOptionListQueryData, onQueryOptionPmsGetAvailableOptionList } =
		Repository.Query.UseCase.useOptionPmsGetAvailableOptionListQuery({ hotelID, date: initSearchDate });

	if (!optionPmsGetAvailableOptionListQueryData) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<CreateOptionPmsPresenter
			hotelID={hotelID}
			onCloseCallback={onCloseCallback}
			optionPmsGetAvailableOptionListQueryData={optionPmsGetAvailableOptionListQueryData}
			initSearchDate={initSearchDate}
			onQueryOptionPmsGetAvailableOptionList={onQueryOptionPmsGetAvailableOptionList}
		/>
	);
};
